<template>
  <v-footer
      app="true"
      absolute="true"
      color="black darken-4"
  >
    <v-row
        justify="center"
        no-gutters="true"
        class="pa-2"
    >
      <v-col
          v-if="$vuetify.display.mdAndUp"
          cols="3"
      >
        <p class="text-uppercase text-h5">
          main road co. ltd
        </p>
        <p class="text-uppercase text-subtitle-2">
          yeonsu-gu songdo, mirae-ro 9, 71
        </p>
        <p class="text-uppercase text-subtitle-2">
          incheon, republic of korea
        </p>
        <p class="text-subtitle-2">
          21988
        </p>
        <p class="pt-6 text-uppercase text-subtitle-1">
          bank name: hana bank
        </p>
        <p class="pt-2 text-uppercase text-subtitle-1">
          bank address: 23, haedoji-ro 120beon-gil,
        </p>
        <p class="text-uppercase text-subtitle-1">
          yeonsu-gu, incheon, republic of korea
        </p>
        <p class="pt-2 text-uppercase text-subtitle-1">
          name: main road trade
        </p>
        <p class="pt-2 text-uppercase text-subtitle-1">
          account number: 427-910014-30638
        </p>
        <p class="pt-2 text-uppercase text-subtitle-1">
          swift code: koexkrse
        </p>
      </v-col>

      <v-col
          v-if="$vuetify.display.mdAndUp"
          cols="6"
      >
        <p class="text-uppercase text-h5 pb-4">
          how to buy
        </p>
        <v-row
            v-for="(value, index) in buySteps"
            :key="value"
        >
          <v-col
              class="py-1 d-flex"
              align-self="center"
          >
            <p class="text-subtitle-1 text-uppercase text-no-wrap mr-2">
              step {{ index + 1 }}
            </p>
            <v-icon :icon="value.icon"/>
            <p class="text-subtitle-1 text-uppercase ml-2">
              {{ value.title }}
            </p>
          </v-col>
        </v-row>
      </v-col>

      <v-col
          cols="12"
          md="2"
      >
        <v-row>
          <v-col
              v-for="link in visibleLinks"
              :key="link"
              cols="6"
              class="d-flex justify-center align-center"
          >
            <v-btn
                :to="link.to"
                color="white"
                variant="text"
                class="mx-2"
                rounded="xl"
            >
              {{ link.title }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col
              cols="12"
              class="d-flex justify-center align-center"
          >
            <v-btn
                class="mx-2"
                icon="mdi-whatsapp"
                color="green"
                href="https://chat.whatsapp.com/BMNOrm3LCxnCRAIDMFxVAF"
            />
            <v-btn
                class="mx-2"
                icon="mdi-instagram"
                color="purple-darken-2"
                href="https://www.instagram.com/mainroad.trade/"
            />
            <v-btn
                class="mx-2"
                icon="mdi-facebook"
                color="blue-darken-2"
                href="https://www.facebook.com/mainroad.trade"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col
          v-if="$vuetify.display.smAndDown"
          class="text-center mt-4"
          cols="12"
      >
        {{ new Date().getFullYear() }} — <strong>©MainroadTrade</strong>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>

import {inject} from "vue";
import {auth} from "@/common/auth";

export default {
  name: "TheFooter",
  data() {
    return {
      links: [
        {
          title: 'Home',
          to: {
            name: 'home'
          },
          roles: ['ALL']
        },
        {
          title: 'Profile',
          to: {
            name: 'profile',
            hash: '#profile'
          },
          roles: ['ROLE_CONFIRMED_USER', 'ROLE_MANAGER', 'ROLE_ADMIN']
        },
        {
          title: 'Orders',
          to: {
            name: 'profile',
            hash: '#orders'
          },
          roles: ['ROLE_CONFIRMED_USER', 'ROLE_MANAGER', 'ROLE_ADMIN']
        },
        {
          title: 'Client orders',
          to: {
            name: 'admin-car-requests-view'
          },
          roles: ['ROLE_MANAGER', 'ROLE_ADMIN']
        },
        {
          title: 'Payments',
          to: {
            name: 'profile',
            hash: '#payments'
          },
          roles: ['ROLE_CONFIRMED_USER', 'ROLE_MANAGER', 'ROLE_ADMIN']
        },
        {
          title: 'Export guide',
          to: {
            name: 'export-guide'
          },
          roles: ['ALL']
        },
        {
          title: 'Accountant',
          to: {
            name: 'accountant-clients-view'
          },
          roles: ['ROLE_ADMIN']
        },
        {
          title: 'About',
          to: {
            name: 'about'
          },
          roles: ['ALL']
        }
      ],
      buySteps: [
        {
          title: 'search car',
          icon: 'mdi-car'
        },
        {
          title: 'send request',
          icon: 'mdi-cart-check'
        },
        {
          title: 'clarifying details of deal',
          icon: 'mdi-text-box-check'
        },
        {
          title: 'general check-up of the vehicle and photo/video review',
          icon: 'mdi-car-info'
        },
        {
          title: 'payment',
          icon: 'mdi-account-cash'
        },
        {
          title: 'shipment',
          icon: 'mdi-ferry'
        },
        {
          title: 'your selfie with car',
          icon: 'mdi-thumb-up'
        }
      ]
    }
  },
  computed: {
    visibleLinks() {
      return this.links.filter(this.isAccessibleByRole)
    }
  },
  setup() {
    return {
      isAuthorized: inject('authorization').isAuthorized
    }
  },
  methods: {
    isAccessibleByRole(menuItem) {
      if (menuItem.roles.includes('ALL')) {
        return true
      }

      if (!this.isAuthorized) {
        return false
      }

      return auth.getRoles().some(role => menuItem.roles.includes(role))
    }
  }
}
</script>

<style scoped>

</style>